import './style.less';

const LinkResource: React.FC = () => {
    return <div className='paddle-inter-link-resource-wrapper'>
        <div className='paddle-inter-link-resource'>
            <div className='paddle-inter-link-resource-title'>
                Get Started with PaddlePaddle Now
            </div>
            <div className='paddle-inter-link-resource-btn'>
                <div className='btn-install' onClick={() => {window.open('./en/install')}}>Install</div>
                <div className='btn-documents' onClick={() => {window.open('./documentation/docs/en/guides/index_en.html')}}>Documents</div>
            </div>
        </div>
    </div>;
};

export default LinkResource;